import { mapResortIdToPath } from '~/utils/resorts';

export default ({ app, store }, inject) => {

    const getResortRoute = (resortId, season = false, type = 'maps') => {
        return app.localePath({
            name: `season-${type}-resort`,
            params: {
                season: season || store.state.currentSeason,
                resort: mapResortIdToPath(resortId, season || store.state.currentSeason),
            },
        });
    };

    const getAbsoluteResortRoute = (resortId, season = false, type = 'maps') => {
        return (app.router.options.base + getResortRoute(resortId, season, type)).replace('//', '/');
    };

    const goToResort = (resortId, season = false, isNativeApp = false) => {
        const type = isNativeApp ? 'native-app' : 'maps';
        app.router.push(getResortRoute(resortId, season, type));
    };

    inject('getResortRoute', getResortRoute);
    inject('getAbsoluteResortRoute', getAbsoluteResortRoute);
    inject('goToResort', goToResort);

    const hasQueryParams = (route) => {
        return !!Object.keys(route.query).length;
    };

    app.router.beforeEach((to, from, next) => {
        if (!hasQueryParams(to) && hasQueryParams(from)) {
            next({ name: to.name, params: to.params, query: from.query });
        } else {
            next();
        }
    });
};
